import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useCustomer } from "@/lib/customerAuth";
import { formatErr } from "@/lib/api";
import { Mail, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const { forgotPassword } = useCustomer();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await forgotPassword(email);
      setDone(true);
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Something went wrong");
    } finally { setBusy(false); }
  };

  if (done) return (
    <div className="max-w-md mx-auto px-6 py-24 text-center">
      <CheckCircle2 className="w-14 h-14 text-[#D71920] mx-auto" />
      <h1 className="font-display text-3xl uppercase mt-4">Check your email</h1>
      <p className="text-sm text-[#555] mt-3">If <strong>{email}</strong> is registered, we've sent a password reset link. It expires in 1 hour.</p>
      <Link to="/login" className="ff-btn-dark mt-8">Back to Sign In</Link>
    </div>
  );

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <div className="text-xs uppercase tracking-widest text-[#D71920] font-bold text-center">Password recovery</div>
      <h1 className="font-display text-4xl uppercase mt-2 text-center">Forgot password</h1>
      <p className="text-sm text-[#555] text-center mt-3">Enter your email and we'll send a reset link.</p>

      <form onSubmit={submit} className="ff-card p-8 mt-8 space-y-4" data-testid="forgot-form">
        <div>
          <label className="text-xs uppercase tracking-widest text-[#666] font-bold">Email</label>
          <div className="relative mt-1">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#999]" />
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="ff-input pl-9" data-testid="forgot-email" />
          </div>
        </div>
        <button type="submit" disabled={busy} className="ff-btn-primary w-full" data-testid="forgot-submit">
          {busy ? "Sending…" : "Send reset link"}
        </button>
      </form>

      <p className="text-center text-sm text-[#555] mt-6">
        <Link to="/login" className="text-[#D71920] font-bold hover:underline" data-testid="back-to-login">Back to Sign In</Link>
      </p>
    </div>
  );
}
